(() => {
  const initialize = (root) => {
    root.querySelectorAll('[data-ocp]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const promotion = section.querySelector('[data-ocp-promotion]');
      if (promotion) {
        const end = Date.parse(promotion.dataset.end);
        const update = () => {
          const remaining = end-Date.now();
          if (!Number.isFinite(end) || remaining<=0) { promotion.hidden=true; return false; }
          const seconds = Math.floor(remaining/1000);
          promotion.querySelector('[data-ocp-timer]').textContent = `${Math.floor(seconds/86400)} j ${Math.floor(seconds%86400/3600)} h ${Math.floor(seconds%3600/60)} min ${seconds%60} s`;
          promotion.hidden=false;
          return true;
        };
        if (update()) { const interval=setInterval(()=>{if(!promotion.isConnected||!update())clearInterval(interval);},1000); }
      }
      const track = section.querySelector('[data-ocp-track]');
      if (!track) return;
      section.querySelector('[data-ocp-prev]')?.addEventListener('click', () => track.scrollBy({left:-track.clientWidth*.8}));
      section.querySelector('[data-ocp-next]')?.addEventListener('click', () => track.scrollBy({left:track.clientWidth*.8}));
      if (section.classList.contains('ocp--offer')) {
        const items = [...track.children];
        const thumbs = document.createElement('div');
        thumbs.className = 'ocp__thumbs';
        items.forEach((item,index) => {
          const image = item.querySelector('img');
          if (!image) return;
          const button = document.createElement('button');
          button.type = 'button';
          button.setAttribute('aria-label', image.alt || `Image ${index+1}`);
          button.setAttribute('aria-pressed', String(index===0));
          const thumbnail = image.cloneNode();
          thumbnail.removeAttribute('srcset');
          thumbnail.removeAttribute('sizes');
          button.append(thumbnail);
          button.addEventListener('click', () => {
            items.forEach((slide,i) => { slide.style.display = i===index?'block':'none'; });
            [...thumbs.children].forEach((b,i) => b.setAttribute('aria-pressed',String(i===index)));
          });
          thumbs.append(button);
        });
        const gallery = document.createElement('div');
        gallery.className = 'ocp__gallery';
        track.before(gallery);
        gallery.append(track,thumbs);
      }
    });
  };
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load',e=>initialize(e.target.parentElement));
})();
